import { render, staticRenderFns } from "./SesionesDocente.vue?vue&type=template&id=67d48e48&"
import script from "./SesionesDocente.vue?vue&type=script&lang=js&"
export * from "./SesionesDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports